import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2 } from '@angular/core';

@Directive({
    selector: '[draggable]',
    standalone: false
})
export class DraggableDirective implements OnInit {

  activated = false;
  initialX: number;
  initialY: number;
  element: any;
  parentImage: any;
  previousY;

  @Output() dragged = new EventEmitter<any>();

  @Input() offsetLeft: number;
  @Input() offsetTop: number;
  @Input() offsetRight: number;
  @Input() offsetBottom: number;

  @Input() clip: any;
  @Input() data: any;

  private offsetRightConst;
  private offsetLeftConst;
  private offsetTopConst;
  private offsetBottomConst;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  ngOnInit() {
    this.element = this.el.nativeElement;
    this.parentImage = this.element.parentNode.querySelector('img#parent').getBoundingClientRect();

  }

  calculateOffset(initial, newConst, maxStart, maxEnd): number {

    const val = (initial - newConst) * -1;

    if (val <= maxStart) {
      return maxStart;
    }
    if (val >= maxEnd) {
      return maxEnd;
    }
    return val;
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: any) {
    this.activated = true;
    this.initialX = Math.floor(event.clientX);
    this.initialY = Math.floor(event.clientY);
    this.previousY = this.clip.offsetY;
    this.offsetLeftConst = -1 * Math.floor(this.clip.offsetX);
    this.offsetRightConst = Math.floor(this.offsetRight);
    this.offsetTopConst = -1 * Math.floor(this.clip.offsetY);
    this.offsetBottomConst = (Math.floor(this.offsetBottom) >= 0 ? Math.floor(this.offsetBottom) : 0);

  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event: any) {
    if (this.activated === true) {
      this.activated = false;
      this.dragged.emit({
        x: this.calculateOffset(this.initialX, (<any>event).clientX, this.offsetLeftConst, this.offsetRightConst),
        y: this.calculateOffset(this.initialY, (<any>event).clientY, this.offsetTopConst, this.offsetBottomConst)
      });
      this.renderer.removeStyle(this.element, 'transform');
    }
  }

  @HostListener('document:mouseleave', ['$event'])
  onMouseLeave() {
    this.activated = false;
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: any) {
    if (!this.activated) {
      return;
    }
    this.renderer.setStyle(
      this.element,
      'transform',
      `translate(${this.calculateOffset(this.initialX, event.clientX, this.offsetLeftConst, this.offsetRightConst)}px,
       ${this.calculateOffset(this.initialY, event.clientY, this.offsetTopConst, this.offsetBottomConst)}px)`);
  }
}
